import request from "@/utils/request";
import { SERVERPATH } from "@/config";

// 获取导航栏有新消息的客户数量
export function CSGetNewCustomerNum(data) {
  return request({
    url: `${SERVERPATH}/CustomerChat/getNewCustomerNum`,
    method: "post",
    data,
  });
}

// 客服列表
export function CSCustomerChatList(data) {
  return request({
    url: `${SERVERPATH}/CustomerChat/customerChatList`,
    method: "post",
    data,
  });
}

// 客服详情
export function CSCustomerChatInfo(data) {
  return request({
    url: `${SERVERPATH}/CustomerChat/customerChatInfo`,
    method: "post",
    data,
  });
}

// 回复消息
export function CSReplyChat(data) {
  return request({
    url: `${SERVERPATH}/CustomerChat/replyChat`,
    method: "post",
    data,
  });
}

// 关键字列表
export function CSKeywordsList(data) {
  return request({
    url: `${SERVERPATH}/CustomerChat/keywordsList`,
    method: "post",
    data,
  });
}

// 关键字详情
export function CSKeywordInfo(data) {
  return request({
    url: `${SERVERPATH}/CustomerChat/keywordInfo`,
    method: "post",
    data,
  });
}

// 关键字新增
export function CSKeywordAdd(data) {
  return request({
    url: `${SERVERPATH}/CustomerChat/keywordAdd`,
    method: "post",
    data,
  });
}

// 关键字编辑
export function CSKeywordEdit(data) {
  return request({
    url: `${SERVERPATH}/CustomerChat/keywordEdit`,
    method: "post",
    data,
  });
}

// 关键字删除
export function CSKeywordDel(data) {
  return request({
    url: `${SERVERPATH}/CustomerChat/keywordDel`,
    method: "post",
    data,
  });
}
